<ng-container *ngIf="!!get">
    <div class="tt-project__cards">
        <tt-card ttHeading="h_info" class="tt-project__card">
            <tt-input ttLabel="project_keyno" [ttModel]="get.project_keyno" ttReadonly></tt-input>
            <tt-input ttLabel="project_name" [(ttModel)]="get.project_name"></tt-input>
            <tt-textarea ttLabel="description" [(ttModel)]="get.description"></tt-textarea>
            <tt-checkbox ttLabel="active" [(ttModel)]="get.active"></tt-checkbox>
            <tt-select ttLabel="businessco" [(ttModel)]="get.businessco_no" [ttData]="companies" ttDataId="businessco_no" ttDataName="company_name"></tt-select>
            <tt-select ttLabel="portal_user_keyno_project_manager" [(ttModel)]="get.portal_user_keyno_project_manager" [ttData]="projectManagers"></tt-select>
            <tt-checkbox ttLabel="project_template" [(ttModel)]="get.project_template"></tt-checkbox>
        </tt-card>

        <tt-card ttHeading="h_other" class="tt-project__card">
            <tt-input ttLabel="cust_no" [ttModel]="get.cust_no" ttReadonly [ttButtons]="customerButtons"></tt-input>
            <tt-search ttLabel="cust_name" [(ttModel)]="get.cust_name" [ttSearch]="searchCustomers" (ttOnSelected)="onCustomerSelected($event)" (ttOnClear)="onCustomerSelected()"></tt-search>
            <tt-input ttLabel="delivery_cust_no" [ttModel]="get.delivery_cust_no" ttReadonly [ttButtons]="deliveryCustomerButtons"></tt-input>
            <tt-search
                ttLabel="show_delivery_cust_name"
                [(ttModel)]="get.show_delivery_cust_name"
                [ttSearch]="searchDeliveryCustomers"
                (ttOnSelected)="onDeliveryCustomerSelected($event)"
                (ttOnClear)="onDeliveryCustomerSelected()"
            ></tt-search>
            <tt-checkbox ttLabel="deladronpurch" [(ttModel)]="get.deladronpurch"></tt-checkbox>
            <tt-field-group>
                <tt-date ttLabel="start" [(ttModel)]="get.start"></tt-date>
                <tt-date ttLabel="end" [(ttModel)]="get.end"></tt-date>
            </tt-field-group>
            <tt-select ttLabel="shift" [(ttModel)]="get.shift_id" [ttData]="shiftTypes" ttShowClearButton></tt-select>
            <tt-select
                ttLabel="timeregister_minutes_precision"
                [(ttModel)]="get.timeregister_minutes_precision"
                [ttData]="minutePrecisions"
                ttDataId="timeregister_minutes_precision"
                ttDataName="timeregister_minutes_precision_name"
            ></tt-select>
        </tt-card>

        <tt-card ttHeading="h_terms" class="tt-project__card">
            <tt-select ttLabel="pricelist" [(ttModel)]="get.pricelist_id" [ttData]="pricelists"></tt-select>
            <tt-select ttLabel="pricelist2" [(ttModel)]="get.pricelist_id2" [ttData]="pricelists"></tt-select>
            <tt-select ttLabel="payment" [(ttModel)]="get.payment_id" [ttData]="paymentTypes"></tt-select>
            <tt-select ttLabel="tax" [(ttModel)]="get.tax_keyno" (ttModelChange)="onTaxKeynoChanged()" [ttData]="taxes"></tt-select>
            <tt-field-group>
                <tt-input-number
                    ttLabel="contract_amount_ex_tax"
                    [(ttModel)]="get.contract_amount_ex_tax"
                    (ttModelChange)="onContractAmountExTaxChanged()"
                    ttFormatNumber
                    ttDecimals="2"
                ></tt-input-number>
                <tt-input-number ttLabel="contract_amount_incl_tax" [ttModel]="get.contract_amount_incl_tax" ttReadonly ttFormatNumber ttDecimals="2"></tt-input-number>
            </tt-field-group>
            <tt-field-group>
                <tt-input-number
                    ttLabel="max_outstanding_pst"
                    [(ttModel)]="get.max_outstanding_pst"
                    (ttModelChange)="onMaxOutstandingPercentageChanged()"
                    ttFormatNumber
                    ttDecimals="2"
                ></tt-input-number>
                <tt-input-number ttLabel="default_outstanding_pst" [(ttModel)]="get.default_outstanding_pst" ttFormatNumber ttDecimals="2"></tt-input-number>
            </tt-field-group>
            <tt-field-group>
                <tt-input-number ttLabel="max_outstanding_amount_ex_tax" [ttModel]="get.max_outstanding_amount_ex_tax" ttReadonly ttFormatNumber ttDecimals="2"></tt-input-number>
                <tt-input-number ttLabel="max_outstanding_amount_incl_tax" [ttModel]="get.max_outstanding_amount_incl_tax" ttReadonly ttFormatNumber ttDecimals="2"></tt-input-number>
            </tt-field-group>
        </tt-card>
    </div>
    <tt-card class="tt-project__card--buttons">
        <tt-button-save (ttClick)="onSave()" [ttLoading]="saving"></tt-button-save>
        <tt-button *ngIf="get.show_delete_button === '1'" ttText="delete" ttIcon="fad fa-trash" ttType="danger" (ttClick)="deleteProject()" [ttLoading]="deleting"></tt-button>
        <tt-button-settings *ngIf="get.show_settings === '1'" ttWebpageName="project"></tt-button-settings>
    </tt-card>
</ng-container>
